/**
 * Theme constants for consumption by libraries that accept style objects
 * as props (e.g. react-vertical-timeline-component's contentStyle / iconStyle).
 * These values must stay in sync with the CSS custom properties in App.css.
 */
export const theme = {
  colorCardBg: "#1d1836",
  colorText: "#fff",
  colorCardArrow: "rgb(24, 26, 35)",
};
